import { render, staticRenderFns } from "./TooltipMenu.vue?vue&type=template&id=88d05f0c&scoped=true"
import script from "./TooltipMenu.vue?vue&type=script&lang=js"
export * from "./TooltipMenu.vue?vue&type=script&lang=js"
import style0 from "./TooltipMenu.vue?vue&type=style&index=0&id=88d05f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d05f0c",
  null
  
)

export default component.exports